import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PressableButton from '../../../components/NewButton';
import ConfirmationModal from './ConfirmationModal';
import styles from './UserGroupAddCard.module.css';
import Styles from '../GroupChatScreen/AddGroupUsersModal/AddGroupUsersMoal.module.css';

const AV_COLORS = ['#800020', '#7c3aed', '#065f46', '#b45309', '#1d4ed8', '#9d174d'];
const getAvColor = name => AV_COLORS[(name?.charCodeAt(0) || 0) % AV_COLORS.length];
const getInitials = name => {
  if (!name) return '?';
  const parts = name.trim().split(' ');
  return parts.length >= 2 ? (parts[0][0] + parts[1][0]).toUpperCase() : parts[0].slice(0, 2).toUpperCase();
};

const UserGroupInforCard = ({ role, loading, duration, onClick, status, name, email, adminControl, handleRemoveUser }) => {
  const { t } = useTranslation();
  const [isLoading, setLoading] = useState(loading);
  const [swipedOut, setSwipedOut] = useState(false);
  const [removeUserConfirmModal, setRemoveUserConfirmModal] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration]);

  const removeHandler = useCallback(() => {
    onClick();
    setRemoveUserConfirmModal(true);
  }, [onClick]);

  const onRemove = useCallback(() => {
    setTimeout(() => setSwipedOut(true), 1000);
    setRemoveUserConfirmModal(false);
    handleRemoveUser();
  }, [handleRemoveUser]);

  return (
    <>
      <div
        style={status === 'pending' ? { opacity: '60%', padding: '6px 12px' } : { padding: '6px 12px' }}
        className={`${styles.card} ${swipedOut ? styles.swipedOut : ''}`}
      >
        {isLoading ? (
          <div className={`${styles.cards}`}>
            <div className={`${styles.card_title} ${styles.loading}`}></div>
          </div>
        ) : (
          <>
            <div className={`${Styles.userRow}`} style={{ width: '100%' }}>
              <div className={Styles.userAv} style={{ background: getAvColor(name) }}>
                {getInitials(name)}
              </div>
              <div className={Styles.userInfo}>
                <span className={Styles.userName}>{name}</span>
                <span className={Styles.userEmail}>{email}</span>
              </div>
              <div>
                {role === 'user' && status === 'accepted' && adminControl && (
                  <PressableButton
                    name={t('screens.chat.remove')}
                    style={{
                      borderRadius: '32px',
                      fontSize: '11px',
                      padding: '6px 16px',
                    }}
                    onClick={removeHandler}
                  />
                )}
                {role === 'admin' && <span className={styles.adminText}>{t('screens.chat.userAdmin')}</span>}
                {status === 'pending' && <span className={styles.adminText}>{t('screens.chat.userPending')}</span>}
              </div>
            </div>
          </>
        )}
        <ConfirmationModal
          showModal={removeUserConfirmModal}
          handleRemoveUser={onRemove}
          message={t('screens.chat.removeUserPrompt', { name })}
          buttonLabel={t('screens.chat.removeUserBtn')}
          setShowModal={setRemoveUserConfirmModal}
        />
      </div>
    </>
  );
};

export default UserGroupInforCard;
